module.exports = __webpack_public_path__ + "static/media/7.cf43b49a.png";